import React, { useState, useEffect } from "react";
import { Button, Col, Row, Container } from "react-bootstrap";
import { capitalize } from "lodash-es";
import CustomTooltip from "utils/CustomTooltip";
import PlatformSpecific from "./PlatformSpecific";

function ApiAccess(props) {
  // Simplified platform state handling
  const [platforms, setPlatforms] = useState(props.api_platforms);
  const [mccId, setMccId] = useState(props.organization.google_ads_mcc_id);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const googleAds = platforms.google_ads;
    const showAlertCondition = googleAds.authenticated && (!mccId || mccId.length !== 10);
    setShowAlert(showAlertCondition);
  }, [platforms.google_ads, mccId]);


  const openAuthPage = (authUrl) => {
    window.open(authUrl, "_blank");
  };


  useEffect(() => {
    const checkAuthStatusForAllPlatforms = () => {
      // Loop through each platform and check the authentication status
      Object.keys(platforms).forEach((platformKey) => {
        fetch(`/datapulse/api-access/check-status?platform=${platformKey}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.authenticated !== platforms[platformKey].authenticated) {
              setPlatforms((prevPlatforms) => ({
                ...prevPlatforms,
                [platformKey]: { ...prevPlatforms[platformKey], authenticated: data.authenticated },
              }));
            }
          })
          .catch((error) => console.error(`Error checking ${platformKey} auth status`, error));
      });
    };
  
    const intervalId = setInterval(checkAuthStatusForAllPlatforms, 2000); // check every 2 seconds
  
    return () => clearInterval(intervalId); // Clean up the interval when the component unmounts
  }, [platforms]);
  

  const renderAuthButton = (platformKey) => {
    const platform = platforms[platformKey];
    const isGoogleService = platform.title.toLowerCase().includes("google");
  
    if (platform.authenticated) {
      return (
        <>
          <Button className="mb-4 btn-lg api-button text-center" variant="danger" onClick={() => openAuthPage(platform.deauth_url)}>
            Reset Token
            <CustomTooltip faClass="text-white far fa-question-circle f18 pl-2" message={`Resetting ${capitalize(platform.title)} token will require you to authenticate again`} inline={true} />
          </Button>
        </>
      );
    } else if (isGoogleService) {
      const googleBtn = require("images/google/btn_google_signin_light_normal_web.png");
      return (
        <div onClick={() => openAuthPage(platform.auth_url)}>
          <img className="api-google-button mx-auto mb-4" src={`/datapulse${googleBtn}`} alt="Google Sign-In" />
        </div>
      );
    } else {
      return (
        <>
          <Button className="mb-4 api-button btn-lg text-center" variant="success" onClick={() => openAuthPage(platform.auth_url)}>
            Authenticate
            <i className="fas fa-cog pl-2" style={{ paddingRight: "0px", color: "unset", float: "unset" }}></i>
          </Button>
        </>
      );
    }
  };

  return (
    <>
      <div className="standard-page-padding">
        <h1>Data Connections</h1>
        <p className="pb-4"><b>Note: Access to some platforms is handled on the account level. Please go to Account Settings to authorize them.</b></p>
        <div className="d-flex flex-column gap-24">
          <div className="basic-info-container prim-bg p-4">
            <div>
              <h5>Authenticate with the services you need to pull for your clients.</h5>
            </div>
            <div style={{ maxWidth: "1400px", margin: "0 auto" }} className="mt-5 api-container mb-5 d-flex flex-wrap gap-32">
              {Object.keys(platforms).map((platformKey, index) => {
                const platform = platforms[platformKey];
                const apiTitle = platformKey === "search_console" ? "Google Search Console" : platform.title;
                return (
                  <div key={index} className="text-center api-access-col">
                    <h4 className="f20">{apiTitle}</h4>
                    {renderAuthButton(platformKey)}
                  </div>
                );
              })}
            </div>
          </div>
          <PlatformSpecific showAlert={showAlert} mccId={mccId} setMccId={setMccId} {...props} />
        </div>
      </div>
    </>
  );
}

export default ApiAccess;